module.exports = __webpack_public_path__ + "img/ios-arrow-round-up.14aa8e97.svg";